import React from 'react';
import { Input, Form, DatePicker, Button, Row, Col, Icon, Select } from 'antd';
import { removePropertyOfNull } from '../../../utils';
import moment from 'moment';

const { RangePicker } = DatePicker;
const { Option } = Select;

const SearchRender = ({ form, onFinish }) => {
	const formItemLayout = {
		labelCol: { span: 8 },
		wrapperCol: { span: 16 },
	};

	const buttonItemLayout = {
		wrapperCol: { span: 24 },
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		form.validateFields((err, values) => {
			if (!err) {
				onFinish(removePropertyOfNull(values));
			}
		});
	};

	const reset = () => {
		form.resetFields();
	};

	return (
		<Form {...formItemLayout}>
			<Row gutter={24} style={{ marginBottom: '12px' }}>
				<Col span={3}>
					<Form.Item label="产品" style={{ fontSize: '14px' }}>
						{form.getFieldDecorator('guarantee_type', { initialValue: '' })(
							<Select style={{ width: '100%', fontSize: '12px', color: 'blue' }}>
								<Option key="0" value="">
									全部
								</Option>
								<Option key="1" value="0">
									企信宝
								</Option>
								<Option key="2" value="1">
									大经宝
								</Option>
							</Select>
						)}
					</Form.Item>
				</Col>
				<Col span={3}>
					<Form.Item label="订单号" style={{ fontSize: '14px' }}>
						{form.getFieldDecorator('order_no', {})(
							<Input placeholder="订单号" style={{ width: '100%', fontSize: '12px' }} />
						)}
					</Form.Item>
				</Col>
				<Col span={3}>
					<Form.Item label="审批状态" style={{ fontSize: '14px' }}>
						{form.getFieldDecorator('status', {})(
							<Select placeholder="状态" style={{ width: '100%', fontSize: '12px' }}>
								<Option key="1" value={''}>
									全部
								</Option>
								<Option key="2" value={'待批准'}>
									待批准
								</Option>
								<Option key="3" value={'同意'}>
									同意
								</Option>
								<Option key="4" value={'拒绝'}>
									拒绝
								</Option>
								<Option key="5" value={'作废'}>
									作废
								</Option>
							</Select>
						)}
					</Form.Item>
				</Col>
				<Col span={3}>
					<Form.Item label="子公司" style={{ fontSize: '14px' }}>
						{form.getFieldDecorator('company', {})(
							<Input placeholder="子公司名称" style={{ width: '100%', fontSize: '12px' }} />
						)}
					</Form.Item>
				</Col>
				<Col span={3}>
					<Form.Item label="客户名称" style={{ fontSize: '14px' }}>
						{form.getFieldDecorator('clientName', {})(
							<Input placeholder="客户名称" style={{ width: '100%', fontSize: '12px' }} />
						)}
					</Form.Item>
				</Col>
				<Col span={3}>
					<Form.Item label="还款状态" style={{ fontSize: '14px' }}>
						{form.getFieldDecorator('repay_type', {})(
							<Select placeholder="状态" style={{ width: '100%', fontSize: '12px' }}>
								<Option key="1" value={''}>
									全部
								</Option>
								<Option key="2" value={'06'}>
									结清
								</Option>
								<Option key="3" value={'05'}>
									未结清
								</Option>
								<Option key="4" value={'08'}>
									代偿未清
								</Option>
								<Option key="5" value={'09'}>
									代偿已清
								</Option>
							</Select>
						)}
					</Form.Item>
				</Col>
				<Col span={2}>
					<Form.Item label="日期" style={{ fontSize: '14px' }}>
						{form.getFieldDecorator('created_at', {})(
							<RangePicker
								showTime={{ defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('00:00:00', 'HH:mm:ss')] }}
							/>
						)}
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={24} style={{ marginBottom: '12px' }}>
				<Col span={24}>
					<Form.Item {...buttonItemLayout}>
						<Button type="primary" onClick={handleSubmit} style={{ marginRight: 8 }}>
							<Icon type="search" /> 查询
						</Button>
						<Button type="default" onClick={reset}>
							<Icon type="redo" /> 重置
						</Button>
					</Form.Item>
				</Col>
			</Row>
		</Form>
	);
};

export default Form.create()(SearchRender);
